import RegionApi from './RegionApi';
import DistrictApi from './DistrictApi';
import FormationSanitaireApi from './FormationSanitaireApi';
import Region from '../modeles/Region';
import District from '../modeles/District';
import FormationSanitaire from '../modeles/FormationSanitaire';

export default class PilotageStructuresApi {
  static async obtenirRegions(): Promise<Region[]> {
    const result = await RegionApi.obtenirToutesLesRegions();
    return Array.from(result);
  }

  static async ajouterRegion(nom: string): Promise<void> {
    return RegionApi.ajouterRegion({ nom });
  }

  static async modifierRegion(id: string, nom: string): Promise<void> {
    return RegionApi.modifierRegion(id, { nom });
  }

  static async supprimerRegion(id: string): Promise<void> {
    return RegionApi.supprimerRegion(id);
  }

  static async obtenirDistricts(regionId: string): Promise<District[]> {
    const result = await DistrictApi.obtenirDistrictsRegionCourante(regionId);
    return Array.from(result);
  }

  static async ajouterDistrict(nom: string, regionId: string): Promise<void> {
    return DistrictApi.ajouterDistrict({ nom, idRegion: regionId });
  }

  static async modifierDistrict(id: string, nom: string, regionId: string): Promise<void> {
    return DistrictApi.modifierDistrict(id, { nom, idRegion: regionId });
  }

  static async supprimerDistrict(id: string): Promise<void> {
    return DistrictApi.supprimerDistrict(id);
  }

  static async obtenirFormationsSanitaires(districtId: string): Promise<FormationSanitaire[]> {
    if (!districtId) return [];
    return FormationSanitaireApi.obtenirFormationsSanitaires(districtId);
  }

  static async obtenirFormationSanitaireParId(id: string): Promise<FormationSanitaire | null> {
    return FormationSanitaireApi.obtenirFormationSanitaireParId(id);
  }

  static async ajouterFormationSanitaire(nom: string, districtId: string): Promise<void> {
    return FormationSanitaireApi.ajouterFormationSanitaire({ nom, idDistrict: districtId });
  }

  static async modifierFormationSanitaire(id: string, nom: string, districtId: string): Promise<void> {
    return FormationSanitaireApi.modifierFormationSanitaire({ id, nom, idDistrict: districtId });
  }

  static async supprimerFormationSanitaire(id: string): Promise<void> {
    return FormationSanitaireApi.supprimerFormationSanitaire(id);
  }
}